import { Clickable } from '@carvana/vdp-components';
import { useContext } from 'react';
import MoreDetailsModalSections from '~/constants/MoreDetailsModalSections';
import ModalContext from '~/contexts/ModalContext';
import { useTileDataContext } from '~/contexts/TileDataContext';
import Tag from './Tag';

type OwnProps = {
  textToDisplay: string;
};

const AvailabilityTag = ({ textToDisplay }: OwnProps) => {
  const { tileData } = useTileDataContext();
  const { setMoreDetailsModalOpen } = useContext(ModalContext);

  return (
    <Clickable
      data-analytics-id="open-result-tile-modal"
      data-analytics-attributes={JSON.stringify({
        clickedSource: 'Days to delivery tag'
      })}
      data-qa="days-to-delivery-tag"
      className="pointer-events-auto"
      onClick={e => {
        e.preventDefault();
        setMoreDetailsModalOpen(true, {
          openTo: MoreDetailsModalSections.Availability,
          vehicle: tileData
        });
      }}
    >
      <Tag text={textToDisplay} border blueText bgColor="bg-white" />
    </Clickable>
  );
};

export default AvailabilityTag;
